<template>
  <div class="template">
    <H5>VEGA CONTINGÊNCIA DESATIVADO</H5>
    <p>
      Atenção! Esse canal está indisponível, pois o modo contingência está
      desativado.
    </p>
  </div>
</template>

<script>
export default {
  name: "DisabledPage",
  setup() {},
};
</script>

<style lang="scss" scoped>
.template {
  height: 100vh;
  background: #e5e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
h5 {
  margin: 0;
}
</style>
